// extracted by mini-css-extract-plugin
export default {"hero":"Hero5_hero__Lt7wl","images":"Hero5_images__pvjKi","image":"Hero5_image__QBLJl","textOverlay":"Hero5_textOverlay__uTTcS","title":"Hero5_title__6+0RP"};